<managed-list
    [legend]="'Content Hold'"
    [fields]="fields"
    [type]="'content-hold'"
    [fbFields]="properties"
    submitURL="content-hold"
></managed-list>